import React from "react";
import "./MandatoryDisclosure.css";
import etrPdf from "../assets/ETR VVCMS.pdf";
import giftDeedPdf from "../assets/VVES_Registration_Doc.pdf";
import buildingSafetyPdf from "../assets/VVCMS_Building_Safty_Certificate.pdf";
import fireNocPdf from "../assets/vvcms fire NOC.pdf";
import sanitaryPdf from "../assets/VVCMS_Safe_drinking_and_Sanitary_Condition_ Certificate.pdf";
import feesPdf from "../assets/VVCMS_Fees_Structure.pdf";
import calendarPdf from "../assets/VVCMS_Annual_Calender.pdf";
import smcPdf from "../assets/VVCMS_School management committee.pdf";
import ptaPdf from "../assets/VVCMS_PARENT TEACHER ASSOCIATION.pdf";
import selfpdf from "../assets/self certificate.pdf";

const ActionLinks = ({ url, filename }) => {
  if (!url) return <span style={{color: '#94a3b8', cursor: 'not-allowed', textDecoration: 'none'}}>Not Available</span>;
  return (
    <div className="md-action-links">
      <a href={url} target="_blank" rel="noreferrer" className="md-view-link">View</a>
      <span className="md-divider">|</span>
      <a href={url} download={filename || "document.pdf"} className="md-download-link">Download</a>
    </div>
  );
};

const MandatoryDisclosure = () => {
  return (
    <div className="md-container">
      <div className="md-header">
        <h2>APPENDIX -IX</h2>
        <h1>MANDATORY PUBLIC DISCLOSURE</h1>
      </div>

      {/* SECTION A */}
      <section className="md-section">
        <h3 className="md-section-title">A : GENERAL INFORMATION :</h3>
        <div className="md-table-wrapper">
          <table className="md-table">
            <thead>
              <tr>
                <th>SL NO.</th>
                <th>INFORMATION</th>
                <th>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>NAME OF THE SCHOOL</td><td>VIVEK VARDHINI CREATIVE MINDS SCHOOL</td></tr>
              <tr><td>2</td><td>AFFILIATION NO.(IF APPLICABLE)</td><td>NA</td></tr>
              <tr><td>3</td><td>SCHOOL CODE (IF APPLICABLE)</td><td>NA</td></tr>
              <tr><td>4</td><td>COMPLETE ADDRESS WITH PIN CODE</td><td>5-1-524, JAMBAGH, DHARAMVEER WAMAN NAIK MARG, HYDERABAD, TELANGANA - 500095</td></tr>
              <tr><td>5</td><td>PRINCIPAL NAME</td><td>KANAMATHAREDDY SRIDHAR REDDY</td></tr>
              <tr><td>6</td><td>PRINCIPAL QUALIFICATION</td><td>M. Sc,B.Ed</td></tr>
              <tr><td>7</td><td>SCHOOL EMAIL ID</td><td>vvcmschool@gmail.com</td></tr>
              <tr><td>8</td><td>CONTACT DETAILS</td><td>63008971671</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* SECTION B */}
      <section className="md-section">
        <h3 className="md-section-title">B : DOCUMENTS AND INFORMATION:</h3>
        <div className="md-table-wrapper">
          <table className="md-table">
            <thead>
              <tr>
                <th>SL NO.</th>
                <th>DOCUMENTS/INFORMATION</th>
                <th>LINKS OF UPLOADED DOCUMENTS ON YOUR SCHOOL'S WEBSITE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY</td>
                <td>NA</td>
              </tr>
              <tr>
                <td>2</td>
                <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE</td>
                <td><ActionLinks url={giftDeedPdf} filename="VVCMS_Gift_deed.pdf" /></td>
              </tr>
              <tr>
                <td>3</td>
                <td>COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT</td>
                <td>NA</td>
              </tr>
              <tr>
                <td>4</td>
                <td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT'S RENEWAL IF APPLICABLE</td>
                <td><ActionLinks url={etrPdf} filename="ETR_VVCMS_Recognition.pdf" /></td>
              </tr>
              <tr>
                <td>5</td>
                <td>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</td>
                <td><ActionLinks url={buildingSafetyPdf} filename="Building_Safety_Certificate.pdf" /></td>
              </tr>
              <tr>
                <td>6</td>
                <td>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</td>
                <td><ActionLinks url={fireNocPdf} filename="Fire_NOC.pdf" /></td>
              </tr>
              <tr>
                <td>7</td>
                <td>COPY OF THE SELF CERTIFICATION SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATION</td>
                <td><ActionLinks url={selfpdf} filename="Self_Certification.pdf" /></td>
              </tr>
              <tr>
                <td>8</td>
                <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td>
                <td>
                  <div style={{ marginBottom: '10px' }}>
                    <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Sanitary Certificate:</span>
                    <ActionLinks url={sanitaryPdf} filename="Sanitary_Certificate.pdf" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="md-note">
          <strong>NOTE:</strong> THE SCHOOLS NEEDS TO UPLOAD THE SELF ATTESTED COPIES OF ABOVE LISTED DOCUMETNS BY CHAIRMAN/MANAGER/SECRETARY AND PRINCIPAL. IN CASE, IT IS NOTICED AT LATER STAGE THAT UPLOADED DOCUMENTS ARE NOT GENUINE THEN SCHOOL SHALL BE LIABLE FOR ACTION AS PER NORMS.
        </p>
      </section>

      {/* SECTION C */}
      <section className="md-section">
        <h3 className="md-section-title">C : RESULT AND ACADEMICS :</h3>
        <div className="md-table-wrapper">
          <table className="md-table">
            <thead>
              <tr>
                <th>SL NO.</th>
                <th>DOCUMENTS/INFORMATION</th>
                <th>LINKS OF UPLOADED DOCUMENTS ON YOUR SCHOOL'S WEBSITE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>FEE STRUCTURE OF THE SCHOOL</td>
                <td><ActionLinks url={feesPdf} filename="Fees_Structure.pdf" /></td>
              </tr>
              <tr>
                <td>2</td>
                <td>ANNUAL ACADEMIC CALENDER</td>
                <td><ActionLinks url={calendarPdf} filename="Annual_Calendar.pdf" /></td>
              </tr>
              <tr>
                <td>3</td>
                <td>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</td>
                <td><ActionLinks url={smcPdf} filename="VVCMS_School_management_committee.pdf" /></td>
              </tr>
              <tr>
                <td>4</td>
                <td>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</td>
                <td><ActionLinks url={ptaPdf} filename="VVCMS_PARENT_TEACHER_ASSOCIATION.pdf" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* SECTION D */}
      <section className="md-section">
        <h3 className="md-section-title">D : STAFF (TEACHING) :</h3>
        <div className="md-table-wrapper">
          <table className="md-table">
            <thead>
              <tr>
                <th>SL NO.</th>
                <th>INFORMATION</th>
                <th>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>PRINCIPAL</td><td>KanamathaReddy Sridhar Reddy</td></tr>
              <tr>
                <td rowSpan="4">2</td>
                <td>TOTAL NO. OF TEACHERS</td>
                <td>12</td>
              </tr>
              <tr>
                <td style={{ paddingLeft: '30px' }}>NTT</td>
                <td>4</td>
              </tr>
              <tr>
                <td style={{ paddingLeft: '30px' }}>TGT</td>
                <td>7</td>
              </tr>
              <tr>
                <td style={{ paddingLeft: '30px' }}>PRT</td>
                <td>6</td>
              </tr>
              <tr><td>3</td><td>TEACHERS SECTION RATIO</td><td>1:25</td></tr>
              <tr><td>4</td><td>DETAILS OF SPECIAL EDUCATOR</td><td>1</td></tr>
              <tr><td>5</td><td>DETAILS OF COUNSELLOR AND WELLNESS TEACHER</td><td>1</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* RESULT CLASS X & XII */}
      <div className="md-row-tables">
        <section className="md-section md-half">
          <h3 className="md-section-title">RESULT CLASS: X</h3>
          <div className="md-table-wrapper">
            <table className="md-table">
              <thead>
                <tr>
                  <th>SL NO.</th>
                  <th>YEAR</th>
                  <th>NO. OF REGISTERED STUDENTS</th>
                  <th>NO. OF STUDENTS PASSED</th>
                  <th>PASS PERCENTAGE</th>
                  <th>REMARKS</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>1</td><td>2024</td><td>0</td><td>0</td><td>0</td><td>NA</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="md-section md-half">
          <h3 className="md-section-title">RESULT CLASS: XII</h3>
          <div className="md-table-wrapper">
            <table className="md-table">
              <thead>
                <tr>
                  <th>SL NO.</th>
                  <th>YEAR</th>
                  <th>NO. OF REGISTERED STUDENTS</th>
                  <th>NO. OF STUDENTS PASSED</th>
                  <th>PASS PERCENTAGE</th>
                  <th>REMARKS</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>1</td><td>2024</td><td>0</td><td>0</td><td>0</td><td>NA</td></tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* SECTION E */}
      <section className="md-section">
        <h3 className="md-section-title">E : SCHOOL INFRASTRUCTURE:</h3>
        <div className="md-table-wrapper">
          <table className="md-table">
            <thead>
              <tr>
                <th>SL NO.</th>
                <th>INFORMATION</th>
                <th>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQ MTR)</td><td>6166</td></tr>
              <tr><td>2</td><td>NO. AND SIZE OF THE CLASS ROOMS (IN SQ MTR)</td><td>26 X 46.42</td></tr>
              <tr><td>3</td><td>NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)</td><td>3 X 63</td></tr>
              <tr><td>4</td><td>INTERNET FACILITY</td><td>YES</td></tr>
              <tr><td>5</td><td>NO. OF GIRLS TOILETS</td><td>10</td></tr>
              <tr><td>6</td><td>NO. OF BOYS TOILETS</td><td>10</td></tr>
              <tr>
                <td>7</td>
                <td>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL</td>
                <td><a href="https://youtu.be/lxRoDwtFGdY" target="_blank" rel="noreferrer" className="md-view-link">Watch Video</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* SECTION F */}
      <section className="md-section">
        <h3 className="md-section-title">F : TEACHER DETAILS:</h3>
        <div className="md-table-wrapper">
          <table className="md-table">
            <thead>
              <tr>
                <th>SL NO.</th>
                <th>TEACHER NAME</th>
                <th>DESIGNATION</th>
                <th>QUALIFICATION</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>Ms. Jagmeet Kaur</td><td>NTT</td><td>MSC E.ED</td></tr>
              <tr><td>2</td><td>Ms. Ongole Loocy Mounika</td><td>NTT</td><td>B.com PPTC</td></tr>
              <tr><td>3</td><td>Ms. Bagade Annapurnaadevi</td><td>NTT</td><td>B.com</td></tr>
              <tr><td>4</td><td>Ms. Karnatapu Revathi</td><td>NTT</td><td>B.com., B.Ed.</td></tr>
              <tr><td>5</td><td>Ms. Akshaya Palle</td><td>TGT</td><td>B.Com (comp) pursuing B.Ed</td></tr>
              <tr><td>6</td><td>Ms. Kakarla Rispa</td><td>PRT</td><td>B.Com (comp) pursuing B.Ed</td></tr>
              <tr><td>7</td><td>Ms. Shikha Saraswal</td><td>PRT</td><td>M. Sc, B.Ed</td></tr>
              <tr><td>8</td><td>Ms. Mekala Balachander</td><td>PRT</td><td>M.A, B.Ed</td></tr>
              <tr><td>9</td><td>Mr. Sudhakhar Agari</td><td>Health and Wellness</td><td> </td></tr>
              <tr><td>10</td><td>Ms. Gouri Govind Raj</td><td>PRT</td><td>M.Com, B.Ed</td></tr>
              <tr><td>11</td><td>Ms. Bhagya Shri Dixit</td><td>TGT</td><td>B.A, M.A, B.Ed</td></tr>
              <tr><td>12</td><td>Ms. Jayashree</td><td>TGT</td><td>Social</td></tr>
              <tr><td>13</td><td>Ms. Bhavika Pandey</td><td>TGT</td><td>English</td></tr>
              <tr><td>14</td><td>Ms. Sirisha</td><td>TGT</td><td>Lab Assistant</td></tr>
              <tr><td>15</td><td>Ms. Bhoolaxmi</td><td>PGT</td><td>Health & Wellness</td></tr>
              <tr><td>16</td><td>Ms. Meera Purohit</td><td>TGT</td><td>Library</td></tr>
              <tr><td>17</td><td>Mr. Sadnam Hussain</td><td>PRT</td><td>Math</td></tr>
              <tr><td>18</td><td>Mr. CH.Raju</td><td>PRT</td><td>Psycologist</td></tr>
              <tr><td>19</td><td>P. Siva Satyanarayana</td><td>Sports</td><td>MA B.Ed</td></tr>
            </tbody>
          </table>
        </div>
      </section>

    </div>
  );
};

export default MandatoryDisclosure;
